import { createApp } from 'vue'
import App from './App.vue'

import Datepicker from '@vuepic/vue-datepicker';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@vuepic/vue-datepicker/dist/main.css';
import 'vue-material-design-icons/styles.css';
import {createRouter, createWebHistory} from 'vue-router'

import { createAuth0, authGuard  } from '@auth0/auth0-vue';

import Home from './components/Home.vue';
import Evangelio from './components/EvangelioComponent.vue';
import AdminEvangelios from './components/admin/WIN_Evangelios.vue';
import AdminFormEvangelios from './components/admin/FRM_Evangelios.vue';
import LogIn from './components/LoginComponent.vue';
import NotFound from './components/NotFound.vue';
import ImprimirQR from './components/admin/RPT_CodigoQR.vue';


const app = createApp(App);

app.use( createRouter({
    history: createWebHistory(),
    routes: [
      {path: '/', component: Home },
      {path: '/misa', component: Evangelio},
      {path: '/misas/', component: AdminEvangelios,beforeEnter: authGuard },
      {path: '/misas/agrega', component: AdminFormEvangelios,beforeEnter: authGuard },
      {path: '/misas/editar/:id', component: AdminFormEvangelios, props: true ,beforeEnter: authGuard},
      {path: '/imprimirqr', component: ImprimirQR,beforeEnter: authGuard},
      {path: '/admin', component: LogIn },
      {path: '/:notFound(.*)', component: NotFound }
    ],
    scrollBehavior(_, _2, savedPosition) {
      // console.log(to, from, savedPosition);
      if (savedPosition) {
        return savedPosition;
      }
      return { left: 0, top: 0 };
    }
})) 

app.use(
    createAuth0({
        domain: "dev-yb21pnej.us.auth0.com",
        client_id: "vZZsFrFQUqIYJCOjRtA6S6QDOMHvrdKD",
        redirect_uri: window.location.origin
    })
);

app.component('DatePicker', Datepicker);

app.mount('#app')
